import { type ReactNode } from 'react'
import { Logo } from '@highlight/ui'

import { HeroGradient, heroCardClass, heroLabelClass } from './hero-gradient'

const ACTIONS: Array<{ label: string; icon: ReactNode; indent: string }> = [
  {
    label: 'Send follow-up to Jane',
    icon: <Logo name="gmail" size="md" />,
    indent: 'left-0 right-[22px] top-0 opacity-50',
  },
  {
    label: 'Send feedback on Kyle to #recruiting',
    icon: <Logo name="slack" size="md" />,
    indent: 'left-[22px] right-0 top-8',
  },
]

/** Step 4: example drafted actions waiting for review in the Outbox. */
export function HeroOutbox() {
  return (
    <HeroGradient>
      <div className="relative h-[119px] w-full">
        {ACTIONS.map(({ label, icon, indent }) => (
          <div
            key={label}
            className={`${heroCardClass} absolute flex items-start gap-2 p-3 shadow-[0_2px_4px_rgba(0,0,0,0.08)] ${indent}`}
          >
            <span className="corner-smooth border-black-5 flex size-5 shrink-0 items-center justify-center rounded-md border bg-white shadow-[0_0_1px_rgba(0,0,0,0.05)]">
              {icon}
            </span>
            <p className={`${heroLabelClass} min-w-0 flex-1 leading-5`}>{label}</p>
          </div>
        ))}
      </div>
    </HeroGradient>
  )
}
